// data/items/gems.js
// Gems from gem rocks - used in crafting jewelry

export const GEMS = [
    { id: 'sapphire', name: 'Sapphire', color: '#0f52ba', value: 50, sprite: { sheet: 'assets/icons/mining/sapphire.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'emerald', name: 'Emerald', color: '#50c878', value: 100, sprite: { sheet: 'assets/icons/mining/emerald.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'ruby', name: 'Ruby', color: '#e0115f', value: 175, sprite: { sheet: 'assets/icons/mining/ruby.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'diamond', name: 'Diamond', color: '#b9f2ff', value: 275, sprite: { sheet: 'assets/icons/mining/diamond.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'astryx_stone', name: 'Astryx Stone', color: '#9932cc', value: 400, sprite: { sheet: 'assets/icons/mining/astryx_stone.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'onyx', name: 'Onyx', color: '#353839', value: 600, sprite: { sheet: 'assets/icons/mining/onyx.png', x: 0, y: 0, width: 64, height: 64 } }
];

export default GEMS;
